var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { API } from 'globals/api';
import { USER_SERVICE_ENDPOINTS } from 'globals/apiEndPoints';
import { constructName, filterCareAgentDataByName } from 'globals/global.functions';
/**
 * @function getCareAgentService
 * @description method to get care agent data via api response.
 * @param {*} params
 * @returns agent accounts.
 */
export function getCareAgentService(params) {
    return __awaiter(this, void 0, Promise, function () {
        var response, results, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, API({
                            url: USER_SERVICE_ENDPOINTS.GET_CARE_AGENT,
                            method: 'get',
                            params: params,
                        })];
                case 1:
                    response = _a.sent();
                    results = response.data.caregivers;
                    return [2 /*return*/, {
                            result: mapCareAgentPayload(results) || [],
                            lastEvaluatedKey: response.data.LastEvaluatedKey,
                        }];
                case 2:
                    error_1 = _a.sent();
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * @function getCareAgentServiceAdmin
 * @description method to get care agent data via api response.
 * @searchQuery {*} searchQuery
 * @returns agent accounts.
 */
export function getCareAgentServiceAdmin(search, searchMember, role, status, isActive) {
    return __awaiter(this, void 0, Promise, function () {
        var url, queryParams, isNumber, response, results, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = USER_SERVICE_ENDPOINTS.GET_CARE_AGENT_ADMIN;
                    queryParams = [];
                    isNumber = !isNaN(search) && search.trim() !== '';
                    if (searchMember) {
                        queryParams.push("employee_id=".concat(searchMember));
                    }
                    if (search) {
                        queryParams.push("search_by_name=".concat(search));
                    }
                    if (role) {
                        queryParams.push("role=".concat((role)));
                    }
                    if (typeof status === 'boolean') {
                        queryParams.push("is_first_login=".concat(status));
                    }
                    if (typeof isActive === 'boolean') {
                        queryParams.push("is_active=".concat(isActive));
                    }
                    if (queryParams.length > 0) {
                        url = "".concat(url, "?").concat(queryParams.join('&'));
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, API({
                            url: url,
                            method: 'get',
                        })];
                case 2:
                    response = _a.sent();
                    results = response.data.caregivers;
                    if (search === !isNumber) {
                        results = filterCareAgentDataByName(results, search);
                    }
                    return [2 /*return*/, {
                            result: mapCareAgentPayload(results) || [],
                            lastEvaluatedKey: response.data.LastEvaluatedKey,
                        }];
                case 3:
                    error_2 = _a.sent();
                    throw error_2;
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function getNewCareAgentServiceAdmin(search, role, status, isActive) {
    return __awaiter(this, void 0, Promise, function () {
        var url, queryParams, isNumber, response, results, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = USER_SERVICE_ENDPOINTS.GET_NEW_CARE_AGENT_ADMIN;
                    queryParams = [];
                    isNumber = !isNaN(search) && search.trim() !== '';
                    if (search) {
                        queryParams.push("search_query=".concat(encodeURIComponent(search)));
                    }
                    if (role) {
                        queryParams.push("role=".concat(role));
                    }
                    if (typeof status === 'boolean') {
                        queryParams.push("is_first_login=".concat(status));
                    }
                    if (typeof isActive === 'boolean') {
                        queryParams.push("is_active=".concat(isActive));
                    }
                    if (queryParams.length > 0) {
                        url = "".concat(url, "?").concat(queryParams.join('&'));
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, API({
                            url: url,
                            method: 'get',
                        })];
                case 2:
                    response = _a.sent();
                    results = response.data.accounts;
                    if (search === !isNumber) {
                        results = filterCareAgentDataByName(results, search);
                    }
                    return [2 /*return*/, {
                            result: mapCareAgentPayload(results) || [],
                            lastEvaluatedKey: response.data.LastEvaluatedKey,
                        }];
                case 3:
                    error_3 = _a.sent();
                    throw error_3;
                case 4: return [2 /*return*/];
            }
        });
    });
}
/**
 * @function mapCareAgentPayload
 * @description method to map care agent account data.
 * @param {*} data
 * @returns {ICareAgentAPIData[]} agent accounts data.
 */
export var mapCareAgentPayload = function (data) {
    if (Array.isArray(data)) {
        return data.map(function (careAgentData) {
            return createCareAgentData(careAgentData);
        });
    }
    return createCareAgentData(data);
};
/**
 * @function createCareAgentData
 * @description method to create care agent account data.
 * @param {*} data
 * @returns {ICareAgentData} agent accounts data in required format.
 */
export var createCareAgentData = function (data) {
    var _a, _b, _c;
    return ({
        userId: data.user_id || '',
        employeeId: data.employee_id || '',
        name: {
            firstName: data.name.first_name,
            lastName: data.name.last_name,
            middleName: data.name.middle_name,
        },
        fullName: constructName(data.name.first_name, '', data.name.last_name),
        email: data.email || '',
        phone: ((_a = data === null || data === void 0 ? void 0 : data.phone_number) === null || _a === void 0 ? void 0 : _a.number) || '',
        extension: ((_b = data === null || data === void 0 ? void 0 : data.phone_number) === null || _b === void 0 ? void 0 : _b.ext) || '',
        accessRole: data.role || 'careagent',
        isFirstLogin: data.is_first_login,
        location: data.location,
        shift: data.shift || '',
        timezone: ((_c = data.location) === null || _c === void 0 ? void 0 : _c.timezone) || '',
        assignedSenior: data.assigned_senior || [],
        is_mfa_enabled: data.is_mfa_enabled || '',
        is_active: data.is_active,
    });
};
/**
 * @function searchCareAgentByLocation
 * @description method to search care agent data by location.
 * @param {*} location
 * @param {*} status
 * @returns agent accounts filtered by location
 */
export function searchCareAgentByLocation(location, searchLastEvaluatedKey, shiftValue) {
    return __awaiter(this, void 0, Promise, function () {
        var url, queryParams, response, results, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = USER_SERVICE_ENDPOINTS.GET_CARE_AGENT_ADMIN;
                    queryParams = [];
                    if (location) {
                        queryParams.push("search_by_location=".concat(encodeURIComponent(location)));
                    }
                    // if (role) {
                    //   queryParams.push(`role=${encodeURIComponent(role)}`);
                    // }
                    // if (typeof status === 'boolean') {
                    //   queryParams.push(`is_first_login=${status}`);
                    // }
                    if (queryParams.length > 0) {
                        url = "".concat(url, "?").concat(queryParams.join('&'));
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, API({
                            url: url,
                            method: 'get',
                        })];
                case 2:
                    response = _a.sent();
                    results = response.data.caregivers;
                    return [2 /*return*/, {
                            result: mapCareAgentPayload(results) || [],
                            lastEvaluatedKey: response.data.LastEvaluatedKey,
                        }];
                case 3:
                    error_4 = _a.sent();
                    throw error_4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
